import type { ReactNode } from "react";

import { getApiError } from "@/lib/api-error";
import { cn } from "@/lib/utils";
import { NvButton } from "./nv-button";

export const NV_LOAD_ERROR_MESSAGE = "불러오지 못했어요. 잠시 후 다시 시도해 주세요.";

export interface NvErrorStateProps {
  // What failed: the API message is shown when the backend sent one (e.g. "에이전트를 찾을 수 없어요")
  error?: unknown;
  // Overrides the message derived from `error`
  message?: ReactNode;
  // Renders the [다시 시도] button
  onRetry?: () => void;
  retryLabel?: string;
  // card = same box as NvEmptyState card · plain = text inside a panel that has its own frame
  variant?: "card" | "plain";
  className?: string;
}

// A failed load rendered where the content would be (instead of the global /server-error page).
export function NvErrorState({ error, message, onRetry, retryLabel = "다시 시도", variant = "card", className }: NvErrorStateProps) {
  const text = message ?? getApiError(error)?.message ?? NV_LOAD_ERROR_MESSAGE;
  const retry = onRetry && (
    <NvButton variant="secondary" size="sm" onClick={onRetry}>
      {retryLabel}
    </NvButton>
  );
  if (variant === "plain") {
    return (
      <div role="alert" className={cn("flex flex-col items-center gap-3 py-10 text-center", className)}>
        <p className="text-[13px] leading-4 text-nv-text-secondary">{text}</p>
        {retry}
      </div>
    );
  }
  return (
    <div role="alert" className={cn("flex flex-col items-center gap-4 rounded-nv-card border border-nv-border bg-nv-surface px-10 py-16 text-center", className)}>
      <p className="text-[14px] leading-[22px] text-nv-text-secondary">{text}</p>
      {retry}
    </div>
  );
}
